module.exports = __webpack_public_path__ + "img/eth.a1160263.svg";